import { servicesSelectors } from '@lifesize/nucleus';
import RootState from 'constants/RootState';
import { PresentationError } from 'constants/ErrorTypes';
import { get } from 'lodash';
import { createSelector } from 'reselect';
import { StateProps } from '../components/Home';

const getAuthenticationError = (state: RootState) => get(state, 'app.authenticationError', '');

const getIsExtensionInstallVisible = (state: RootState): boolean => get(state, 'app.isExtensionInstallVisible');

const getIsLoggedIn = (state: RootState): boolean => servicesSelectors.selectConnected(state);

const getPresentationError = (state: RootState) => {
  const hasPresentationError = get(state, 'app.hasPresentationError');
  const proxyIsConnected = servicesSelectors.selectConnected(state);
  if (hasPresentationError) {
    return proxyIsConnected ? PresentationError.ConnectionLostTryAgain : PresentationError.ConnectionLost;
  }
  return PresentationError.NoError;
};

const getPresentationState = (state: RootState) => get(state, 'app.remoting.wirelessPresentation', {});

const getRemotingState = (state: RootState) => get(state, 'app.remoting.controller', {});

const getLoggingId = (state: RootState) => get(state, 'app.loggingId');

const getIsAuthenticating = (state: RootState) => get(state, 'app.isAuthenticating');

const homeSelector = createSelector([
  getAuthenticationError,
  getIsExtensionInstallVisible,
  getIsLoggedIn,
  getLoggingId,
  getPresentationError,
  getPresentationState,
  getRemotingState,
  getIsAuthenticating
], (
  authenticationError: string,
  isExtensionInstallVisible: boolean,
  isLoggedIn: boolean,
  loggingId: string,
  presentationError: PresentationError,
  presentationState: any,
  remotingState: any,
  isAuthenticating: boolean
  ): StateProps => {
    return {
      canPresent: remotingState.canPresent,
      isExtensionInstallVisible,
      isPresenting: isLoggedIn && presentationState.sending,
      isPresenterAuthenticated: isLoggedIn,
      loggingId: loggingId,
      presentationError,
      roomName: remotingState.roomName,
      submitError: authenticationError,
      isAuthenticating
    };
  });

export default homeSelector;



// WEBPACK FOOTER //
// ./src/selectors/home.ts